import { Nullable } from '@/shared/types/app.types'
import { EnumResponse, CommonLaboratoryResponse } from '@/api/services/common.dto'
import { NotificationVariableResponse } from '@/modules/configurationModule/detail/notifications/models/common'

import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { CommonResponsibilityResponse } from '@/api/services/common/responsibility/common-responsibility.dto'

export interface NotificationPredefinedTemplatesModalState {
    id: Nullable<number>,
    active: boolean,
    attachReport: boolean,
    body: string,
    personnelToBeNotifiedList: CommonPersonnelResponse[],
    responsibilitiesToNotify: CommonResponsibilityResponse[],
    shouldNotifyDepartment: boolean,
    shouldNotifyPetitioner: boolean,
    laboratory: Nullable<CommonLaboratoryResponse>,
    subject: string,
    title: string,
    type: Nullable<EnumResponse>,
    customNotificationVariables: NotificationVariableResponse[]
}
export const initialNotificationPredefinedTemplatesModalState =
    (): NotificationPredefinedTemplatesModalState => ({
        active: true,
        attachReport: false,
        body: '',
        personnelToBeNotifiedList: [],
        responsibilitiesToNotify: [],
        shouldNotifyDepartment: false,
        shouldNotifyPetitioner: false,
        laboratory: null,
        subject: '',
        title: '',
        type: null,
        id: null,
        customNotificationVariables: []
    })
